const alertText = type => {
  switch (type) {
    case 'LaborBCSubstantiation':
      return (
        'Once confirmed, the selected employee(s) ' +
        'will be removed from the survey(s) and QRE will not be computed for these employee(s).'
      );
    case 'LaborProjectSubstantiation':
      return (
        'Once confirmed, the selected employee(s) ' +
        'will be removed from the survey(s) and QRE will not be computed for these employee(s).'
      );
    default:
      return '';
  }
};
export default alertText;
